"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableDefaultNull = void 0;
const typebox_1 = require("@sinclair/typebox");
const NullableDefaultNull = (schema) => typebox_1.Type.Union([schema, typebox_1.Type.Null()], { default: null });
exports.NullableDefaultNull = NullableDefaultNull;
//# sourceMappingURL=nullable-default-null.js.map